import { render, staticRenderFns } from "./ToolbarTitle.vue?vue&type=template&id=23007c56&lang=pug&"
import script from "./ToolbarTitle.vue?vue&type=script&lang=ts&"
export * from "./ToolbarTitle.vue?vue&type=script&lang=ts&"
import style0 from "./ToolbarTitle.vue?vue&type=style&index=0&id=23007c56&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports